import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingPageComponent from '../components/landingPage';
import { bankingAlerts, accountAlerts, getDeliveryMethod } from '../actions/actions';
//import { pingEventService } from '../helpers/apiRequestor';



const mapStateToProps = (state) => {
    return {
        landingPage: {
            accountAlert: state.accountAlertsReducer,
            bankingAlert: state.bankingAlertsReducer,
            getDeliveryMethod: state.deliveryMethodReducer
        }
    }
}

const mapDispatchToProps = (dispatch) => (
    bindActionCreators({ bankingAlerts, accountAlerts, getDeliveryMethod }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageComponent);
